<script>
import StoreSearchForm from '@phoenix/mixins/components/store/StoreSearchForm';
import StoreSearchResults from '@phoenix/mixins/components/store/StoreSearchResults';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  mixins: [StoreSearchForm, StoreSearchResults],

  props: {
    locations: {
      type: Array,
      default: () => [],
    },
    allStoresUrl: {
      type: String,
      default: '',
    },
    storeServices: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState('storeSearch', ['currentTab']),

    ...mapGetters('storeSearch', ['searchPerformed']),
  },

  created() {
    if (!this.searchPerformed) {
      this.setStores(this.locations);
    }
  },

  methods: {
    ...mapActions('storeSearch', ['setStores', 'changeCurrentTab']),
  },
};
</script>

<template>
  <div data-cy="store-search-result">
    <store-search-results-tab-map
      :stores="stores"
      :center="center"
      :zoom="zoom"
      :is-suggestion-activated="isSuggestionActivated"
      :all-stores-url="allStoresUrl"
      :should-load-stores-on-bounds-changed="shouldLoadStoresOnBoundsChanged"
      :store-services="storeServices"
      @query="onKeywordInput"
      @change="onSubmit"
      @geolocation="useMyPosition"
    />
  </div>
</template>
